<p>
  Платформата collectoria.bg начислява минимални такси на продавачите <strong>само при успешно сключени сделки</strong>.
  Публикуването на обяви и използването на допълнителни функции е напълно безплатно.
</p>
<h6 class="mt-3">1. Такси при успешно приключена сделка</h6>
<ul>
  <li><strong>Обява с фиксирана цена</strong> – такса в размер на <strong>1.30%</strong> от крайната продажна цена.</li>
  <li><strong>Обява с наддаване (аукцион)</strong> – такса в размер на <strong>1.50%</strong> от крайната продажна цена.
  </li>
</ul>
<p class="mb-1">
  Във всички случаи, таксата е с граници:
</p>
<ul>
  <li><strong>Минимална:</strong> 0.01 лв.</li>
  <li><strong>Максимална:</strong> 95.00 лв.</li>
</ul>
<h6 class="mt-3">2. Безплатни допълнителни функционалности</h6>
<p class="mb-1">
  Следните функции са напълно безплатни и не водят до начисляване на такси:
</p>
<ul>
  <li>Купи сега цена</li>
  <li>Запазена цена</li>
  <li>Удължаване на аукциона</li>
  <li>Приемам ценови предложения</li>
  <li>Автоматично обновяване след завършване без продажба</li>
</ul>
<h6 class="mt-3">3. Кога и как се уреждат таксите?</h6>
<p>
  Таксите се начисляват <strong>след реално осъществена сделка</strong> към сметката на продавача.
</p>
<p class="mb-1">
  Балансът по сметката ви може да се провери в:
</p>
<ul>
  <li><strong>„Профил“ → „Основни данни“</strong></li>
  <li><strong>„Профил“ → „Портфейл“</strong></li>
</ul>
<h6 class="mt-3">4. Погасяване на задължения</h6>
<p>
  Ако балансът ви в края на месеца е <strong>под -5.00 лв.</strong>, трябва да захраните профила си <strong>до 10-то
  число на следващия месец</strong>, за да избегнете ограничение на функционалности.
</p>
<h6 class="mt-3">5. Възстановяване на такси</h6>
<p class="mb-1">
  В случай на неосъществена сделка, може да подадете <strong>заявка за възстановяване на таксата</strong> чрез
  <a class="text-decoration-none" [routerLink]="[appRoutes.root, appRoutes.contactUs]">формата за контакт</a>.
</p>
<ul>
  <li>Заявки се подават <strong>между 10 и 25 дни</strong> след края на обявата.</li>
  <li>Възстановяването се извършва <strong>в срок от 5 календарни дни</strong>, след като заявката бъде одобрена.</li>
</ul>
<div class="alert alert-primary m-0">
  <strong>Важно:</strong> Всички такси се начисляват в български лева и включват ДДС. Платформата не извършва
  директни разплащания между купувач и продавач – тя предоставя отчетност за таксите само по линия на администриране.
</div>
